import {validateNativeMeasurement} from './nativeCapture.js';

const plain=v=>v&&typeof v==='object'&&(Object.getPrototypeOf(v)===Object.prototype||Object.getPrototypeOf(v)===null);
const validDate=v=>{
 if(typeof v!=='string'||v.length>40||!/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(v)||!Number.isFinite(Date.parse(v)))return false;
 const last=new Date(0);last.setUTCFullYear(Number(v.slice(0,4)),Number(v.slice(5,7)),0);
 return Number(v.slice(5,7))>=1&&Number(v.slice(5,7))<=12&&Number(v.slice(8,10))>=1&&Number(v.slice(8,10))<=last.getUTCDate();
};
// Native UUIDs and stable ASCII identifiers use the same case folding in JS/Go.
const validID=v=>typeof v==='string'&&/^[A-Za-z0-9][A-Za-z0-9._:-]{0,79}$/.test(v);
function originalJSON(value){
 let nodes=0;const seen=new Set();
 const visit=(v,depth)=>{
  if(++nodes>512||depth>8)throw Error('The original instrument evidence exceeds its supported size.');
  if(typeof v==='string'&&v.length>4096)throw Error('The original instrument evidence exceeds 4096 bytes.');
  if(v===null||typeof v==='string'||typeof v==='boolean')return;
  if(typeof v==='number'&&Number.isFinite(v))return;
  if((!Array.isArray(v)&&!plain(v))||seen.has(v))throw Error('The original instrument evidence must be complete JSON data.');
  seen.add(v);for(const child of Array.isArray(v)?Array.from(v):Object.values(v))visit(child,depth+1);seen.delete(v);
 };
 if(!plain(value))throw Error('The instrument did not return an original reading.');
 visit(value,0);
 // Match Go's JSON byte accounting (including HTML and line separators).
 const json=JSON.stringify(value).replace(/[<>&\u2028\u2029]/g,c=>'\\u'+c.charCodeAt(0).toString(16).padStart(4,'0'));
 if(new TextEncoder().encode(json).length>4096)throw Error('The original instrument evidence exceeds 4096 bytes.');
 return JSON.parse(json);
}

/** Match only the already supported Swift HueparS120Protocol metre mode.
 * This validates retained evidence; it does not add device commands or infer
 * a reference setting from packet bytes. */
function hueparMetres(packet){
 if(typeof packet!=='string'||!/^[a-f0-9]{28}$/i.test(packet))throw Error('The original Huepar packet is incomplete.');
 const bytes=packet.match(/../g).map(v=>parseInt(v,16)),header=[0xf1,4,1,0,7,1,1,0x31,0x50];
 if(header.some((v,i)=>bytes[i]!==v)||bytes.slice(1,12).reduce((a,b)=>a+b,0)!==bytes[12]*256+bytes[13])throw Error('The original Huepar packet has an unsupported mode or invalid checksum.');
 return(bytes[9]*65536+bytes[10]*256+bytes[11])/100000;
}

/** Retain the actual native payload, including bounded extra JSON fields.
 * Never manufacture LiDAR IDs, confirmation, units or tool metadata. */
export function validateReferenceInstrumentEvidence(value,metres){
 const evidence=originalJSON(value),bluetooth=evidence.source==='bluetooth';
 if(!['bluetooth','lidar'].includes(evidence.source)||!Number.isFinite(metres)||metres<.1||metres>(bluetooth?120:100)||evidence.metres!==metres)throw Error('The reference distance must exactly match the original instrument reading and supported range.');
 validateNativeMeasurement(evidence,bluetooth?'measureBluetooth':'measureLiDAR');
 if(!validDate(evidence.capturedAt))throw Error('The original instrument reading needs a valid capture timestamp.');
 if(bluetooth){
  if(evidence.reference!=='tool-display'||!validID(evidence.readingID))throw Error('The original Huepar reading needs its identity and tool-display reference.');
  if(hueparMetres(evidence.packetHex)!==metres)throw Error('The Huepar distance differs from the original packet. Measure again.');
 }else if(evidence.reference!=='surface')throw Error('The original LiDAR reading must retain its surface reference.');
 return evidence;
}

export function assertDistinctReferenceReadings(a,b){
 const first=a?.sourceEvidence,second=b?.sourceEvidence;
 if(first?.source==='bluetooth'&&second?.source==='bluetooth'&&first.readingID.toLowerCase()===second.readingID.toLowerCase())throw Error('A–C and B–C need separate Huepar readings. Measure the second distance again.');
}
